<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/arrivalOrders' }">{{$t('notFound.home')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('inStorageOrder.inStorageOrder1')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('orderList.orderList2')}}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('arrivalOrder.arrivalOrder2')" clearable v-model="queryInfo.id" size="small"
                  @keyup.enter.native="searchList"></el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('mail.mailTo')}}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('inStorageOrder.inStorageOrder2')" clearable v-model="queryInfo.receiver" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('orderList.orderList4')}}:</div>
              <div class="flex1">
                <el-input
                    :placeholder="$t('orderList.orderList3')"
                    clearable
                    v-model="queryInfo.trackingNumberJpn"
                    size="small"
                    @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('common.createStartDate')}}:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('common.createEndDate')}}:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('orderList.orderList5')}}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('orderList.orderList3')" clearable v-model="queryInfo.trackingNumberCn" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">商品SKU:</div>
              <div class="flex1">
                <el-input placeholder="商品SKU" clearable v-model="queryInfo.goodsNumber" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">品名:</div>
              <div class="flex1">
                <el-input placeholder="品名" clearable v-model="queryInfo.goodsNameCus" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('cart.cart24')}}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('cart.cart24')" clearable v-model="queryInfo.fnsku" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>

          </el-row>
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title1">FBA/YFF/RSL:</div>
            <div class="flex1" style="">
              <el-select v-model="queryInfo.orderType" placeholder="FBA/YFF/RSL" size="small">
                <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        </el-collapse>
        <el-row>
          <el-col :span="24" style="padding: 5px 0" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('reset')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('query')}}</el-button>
              <el-button class="search-btn btn-green" @click="doAddCart">{{$t('orderList.addCart')}}</el-button>
              <el-button class="search-btn btn-green" @click="sendAll">{{$t('inStorageOrder.inStorageOrder3')}}</el-button>
              <el-button class="search-btn btn-green" @click="toSort">{{$t('orderList.orderList156')}}</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >{{$t('search.expandPanel')}}</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >{{$t('search.retractPanel')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative">
        <lx-table :showIndexCode="false" :list="orderList" isSelectTable border stripe :rowKey="'id'" :emptyText="$t('select.select24')" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" @selectionChange="orderSelectedChanged">
          <el-table-column v-for="(item, index) in asyncColumns" :key="index" align="center" :label="item.name" :prop="item.key"
            :width="item.width?item.width:'auto'" :min-width="item.minWidth?item.minWidth:'auto'">
            <template v-slot="scope">
              <!-- 操作 -->
              <div v-if="item.key === 'handle'">
                <el-button class="list-btn btn-blue" @click="toOrderDetail(scope.row)">
                  {{$t('detail')}}
                </el-button>
                <!-- <el-button class="list-btn btn-green" v-if="editOrderStatus.indexOf(scope.row.orderStatus) > -1"
                           @click="toEditOrder(scope.row)">
                  {{$t('editor')}}
                </el-button> -->
                <el-button class="list-btn btn-deepblue" v-if="['1'].indexOf(scope.row.orderStatus) > -1 "
                  @click="toRefundOrder(scope.row)">
                  {{$t('orderList.orderList16')}}
                </el-button>
                <el-button class="list-btn btn-deepblue" v-if="['0','2','4','8','12','16'].indexOf(scope.row.orderStatus) > -1 "
                  @click="toDestroyOrder(scope.row)">
                  {{$t('orderList.orderList18')}}
                </el-button>
                <el-button class="list-btn btn-green"
                  v-if="['0','1','2','4','8','16'].indexOf(scope.row.orderStatus) > -1 && scope.row.goodsCount>1"
                  @click="toSpiltOrder(scope.row)">
                  {{$t('orderList.orderList20')}}
                </el-button>
                <!-- <el-button class="list-btn btn-deepblue" v-if="['0','1','2','16'].indexOf(scope.row.orderStatus) > -1 "
                           @click="toCancelOrder(scope.row)">
                  {{$t('cancel')}}
                </el-button> -->
                <!-- <el-button class="list-btn btn-blue" v-if="billOrderStatus.indexOf(scope.row.orderStatus) > -1 "
                           @click="toOrderBill(scope.row)">
                  {{$t('orderList.orderList21')}}
                </el-button>
                <el-button class="list-btn btn-red" v-if="billOrderPayStatus.indexOf(scope.row.orderStatus) > -1"
                           @click="toOrderBillPay(scope.row)">
                  {{$t('orderList.orderList22')}}
                </el-button> -->
                <!-- <el-button class="list-btn btn-blue" @click="remind(scope.row)">{{$t('orderList.orderList23')}}</el-button> -->
              </div>
              <!-- 订单编号 -->
              <div v-else-if="item.key === 'splitOrderId'">
                <div>
                  <span>{{ scope.row.id }}</span>
                </div>
                <div v-if="scope.row.splitOrderId">
                  <font color="#0082FF" @click="$router.push({name:'orderDetail',query:{id:scope.row.splitOrderId,isEdit:'0'}})"
                    style="cursor: pointer">{{ scope.row.splitOrderId }}-{{ scope.row.splitSeq }}</font>
                </div>
              </div>
              <!-- 创建时间 -->
              <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | dateFormatToSecond }}
              </div>
              <!-- 同捆 -->
              <!-- <el-link v-else-if="item.key === 'tongkunNo'" :underline="true" @click="toTongkunDetail(scope.row)">
                {{ scope.row.tongkunNo == null ? '' : scope.row.tongkunNo + (scope.row.orderCount == null ? '' : '(' + scope.row.orderCount + ')') }}
              </el-link> -->
              <!-- 国内物流 -->
              <div v-else-if="item.key === 'trackingNumberCn'">
                <div class="btn-row"
                  v-if="scope.row.orderStatus!=='0' && scope.row.orderStatus!=='1' &&scope.row.orderStatus!=='2'">
                  {{ scope.row.trackingNumberCn }}
                </div>
                <div class="btn-row"
                  v-if="scope.row.orderStatus==='0' ||scope.row.orderStatus==='1' ||scope.row.orderStatus==='2'">
                  <el-input @blur="saveTrackingNumberCn(scope.row)" :placeholder="$t('orderList.orderList25')"
                    v-model="scope.row.trackingNumberCn" size="small">
                  </el-input>
                </div>
                <div class="btn-row overflowDot" :title="scope.row.cnLogisticsStatus">
                  {{ scope.row.cnLogisticsStatus }}
                </div>
              </div>
              <!-- 国际物流 -->
              <!-- <div v-else-if="item.key === 'trackingNumberJpn'">
                <div class="btn-row">
                  {{ scope.row.trackingNumberJpn }}
                </div>
                <div class="btn-row overflowDot" :title="scope.row.sagawaState">
                  {{ scope.row.sagawaState }}
                </div>
              </div> -->
              <!-- 订单状态 -->
              <div class="btn-row" v-else-if="item.key === 'orderStatus'">
                <p style="margin-bottom: 10px;">{{scope.$index + 1}}</p>
                {{ scope.row.orderStatus | orderStatusFilter }}
              </div>
              <!-- 商品信息 -->
              <div v-else-if="item.key === 'shopInfo'">
                <div class="lx-text-left-row">
                  <div style="width:80px;text-align: right;" class="table-cell-title-min">{{$t('orderList.orderList26')}}：</div>
                  <div style="width:100px">{{scope.row.colour}}</div>
                </div>
                <div class="lx-text-left-row">
                  <div style="width:80px;text-align: right;" class="table-cell-title-min">{{$t('orderList.orderList27')}}：</div>
                  <div style="width:100px"> {{scope.row.goodsSize}}</div>
                </div>
                <div class="lx-text-left-row" style="display:flex">
                  <div style="width:80px;text-align: right;" class="table-cell-title-min">{{$t('orderList.orderList28')}}：</div>
                  <el-input type="textarea" style="width:100px" @change="quickSave($event,scope.row)"
                    v-model="scope.row.goodsNumber" size="mini">
                  </el-input>
                </div>
              </div>
              <!-- 商品数量 -->
              <div v-else-if="item.key === 'shopNum'">
                <div class="lx-text-left">
                  <span class="table-cell-title-mid">{{$t('orderList.orderList29')}}：</span>
                  <span>{{ scope.row.goodsCount }}</span>
                </div>
                <div class="lx-text-left">
                  <span class="table-cell-title-mid">{{$t('orderList.orderList30')}}：</span>
                  <span>{{ scope.row.waitBoxCount }}</span>
                </div>
                <div class="lx-text-left">
                  <span class="table-cell-title-mid">{{$t('orderList.orderList31')}}：</span>
                  <span>{{ scope.row.refundCount }}</span>
                </div>
                <div class="lx-text-left">
                  <span class="table-cell-title-mid">{{$t('orderList.orderList32')}}：</span>
                  <span>{{ scope.row.destroyCount }}</span>
                </div>
              </div>
              <!-- 仓库保管 -->
              <div v-else-if="item.key === 'categoryFlag'">
                {{ scope.row.categoryFlag == 0 ? $t('running.suspended0') : $t('running.suspended1') }}
                <div class="btn-row"
                  v-if="scope.row.categoryFlag == '0' && storeKeepingStatus.indexOf(scope.row.orderStatus) > -1">
                  <el-button class="list-btn btn-blue" @click="toStoreKeeping(scope.row)">
                    {{$t('update')}}
                  </el-button>
                </div>
                <div class="btn-row"
                  v-if="scope.row.categoryFlag == '1' && scope.row.orderStatus == '16' && scope.row.applicationSend != '1'">
                  <el-button class="list-btn btn-green" @click="toSendOrder(scope.row)">
                    {{$t('orderList.orderList33')}}
                  </el-button>
                </div>
              </div>
              <!-- 包装意向 -->
              <div v-else-if="item.key === 'putIntent'">
                {{ scope.row.putIntent | putIntentFilter }}
              </div>
              <!-- 图片 -->
              <div v-else-if="item.key === 'pictureUrl'">
                <img @click="imgclick(scope.row.pictureUrl,true)" v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0"
                  :src="scope.row.pictureUrl + commonData.smallimg" alt="" class="list-image">
                <img v-else src="../../../assets/images/default.png" alt="" class="list-image">
                <div class="btn-row">
                  <el-button class="list-btn-four btn-blue" @click="toGoodsDetail(scope.row)">
                    {{$t('menu.menu5')}}
                  </el-button>
                </div>
              </div>
              <!-- 是否fba -->
              <div v-else-if="item.key === 'orderType'">
                {{ scope.row.orderType | ordertypeFilter }}
                <div v-if="scope.row.orderType == 1">
                  <span style="margin-right: 10px">バーコード:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 0">
                  <span style="margin-right: 10px">FNSKU:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 2">
                  <span style="margin-right: 10px">検品コード※商品バーコード情報:</span>{{ scope.row.fnsku }}
                </div>
<!--                <div v-if="scope.row.orderType == 3">
                  <span style="margin-right: 10px">ZOZOバーコード:</span>{{ scope.row.fnsku }}
                </div>-->
                <div v-if="scope.row.orderType == 4">
                  <span style="margin-right: 10px">RSLバーコード:</span>{{ scope.row.fnsku }}
                </div>
                <div>
                  <span style="margin-right: 10px">品名:</span>{{ scope.row.goodsNameCus }}
                </div>
                <div v-if="scope.row.orderType == 0">
                  <span style="margin-right: 10px">ASIN:</span>{{ scope.row.asin }}
                </div>
              </div>
              <!-- 不良数量 -->
              <div v-else-if="item.key === 'badInfo'">
                <div>
                  <span class="table-cell-title">{{$t('orderList.orderList34')}}：</span>
                  <span>{{ scope.row.badCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title">{{$t('orderList.orderList35')}}：</span>
                  <span>{{ scope.row.reissueCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title">{{$t('orderList.orderList36')}}：</span>
                  <span>{{ scope.row.exchangCount }}</span>
                </div>
              </div>

              <!-- 其他不需要处理的 -->
              <span v-else>
                {{ scope.row[item.key] }}
              </span>
            </template>
          </el-table-column>
        </lx-table>
        <el-pagination class="lx-page-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 拆单 -->
    <el-dialog width="80%" :title="$t('orderList.orderList20')" :visible.sync="splitDialogVisible" @close="splitDialogClosed">
      <el-row>
        <el-col :span="12" class="split-col">
          <el-form label-width="125px" class="demo-ruleForm">
            <div class="split-title">
              {{$t('orderList.orderList37')}}：
            </div>
            <div>
              <el-form-item :label="$t('orderList.orderList38')">
                <el-input v-model="originSpiltOrderInfo.id" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList39')">
                <el-select v-model="originSpiltOrderInfo.orderStatus" :placeholder="$t('address.address38')" size="small"
                  disabled>
                  <el-option v-for="(item,index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList40')">
                <el-input v-model="originSpiltOrderInfo.goodsCount" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList41')">
                <el-input v-model="originSpiltOrderInfo.refundCount" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList42')">
                <el-input v-model="originSpiltOrderInfo.destroyCount" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList43')">
                <el-select v-model="originSpiltOrderInfo.orderType" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="0" value="0" :label="$t('running.suspended1')"></el-option>
                  <el-option key="1" value="1" :label="$t('running.suspended0')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList44')">
                <el-select v-model="originSpiltOrderInfo.categoryFlag" :placeholder="$t('address.address38')" size="small"
                  disabled>
                  <el-option key="1" value="1" :label="$t('running.suspended1')"></el-option>
                  <el-option key="0" value="0" :label="$t('running.suspended0')"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col :span="12" class="split-col">
          <el-form :model="spiltOrderInfo" :rules="spiltOrderRules" ref="spiltInfoForm" label-width="120px" class="split-form">
            <div class="split-title">
              {{$t('orderList.orderList45')}}：
            </div>
            <div>
              <el-form-item :label="$t('orderList.orderList46')">
                <el-select v-model="spiltOrderInfo.orderStatus" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option v-for="(item,index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('createOrder.createOrder23')">
                <el-select v-model="spiltOrderInfo.orderType" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="0" value="0" :label="$t('running.suspended1')"></el-option>
                  <el-option key="1" value="1" :label="$t('running.suspended0')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList47')">
                <el-select v-model="spiltOrderInfo.categoryFlag" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="1" value="1" :label="$t('running.suspended1')"></el-option>
                  <el-option key="0" value="0" :label="$t('running.suspended0')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('excel.excel7')" prop="goodsCount">
                <el-input v-model="spiltOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList48')" prop="refundCount">
                <el-input v-model="spiltOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList49')" prop="destroyCount">
                <el-input v-model="spiltOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="splitDialogVisible = false">{{$t('cancel')}}</el-button>
        <el-button class="form-btn btn-blue" @click="splitSave('spiltInfoForm')">{{$t('submit')}}</el-button>
      </span>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>
  </div>
</template>

<script>
import { columns as originColumns } from "./columns";
import { filterList } from "@/assets/js/utils";
import LxTable from '@/components/LxTable'
import LxSort from "@/components/LxSort/index";
import tableCon from "../../../views/tableContainer";

export default {
  components: {
    LxTable,
    LxSort,
    tableCon,
  },
  data () {
    // 自定义邮箱校验规则
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) <= 0 || parseInt(value) >= parseInt(this.originSpiltOrderInfo.goodsCount)) {
          callback(new Error(this.$t('orderList.orderList56')));
        }
        callback();
      } else {
        callback(new Error(this.$t('orderList.orderList57')));
      }
    };
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.originSpiltOrderInfo.refundCount)) {
          callback(new Error(this.$t('orderList.orderList58')));
        }
        callback();
      } else {
        callback(new Error(this.$t('orderList.orderList59')));
      }
    };
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.originSpiltOrderInfo.destroyCount)) {
          callback(new Error(this.$t('orderList.orderList60')));
        }
        callback();
      } else {
        callback(new Error(this.$t('orderList.orderList61')));
      }
    };
    return {
      isActive:false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: 'instorageOrder'
      },
      visible: false,
      imgurl: '',
      queryInfo: {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        orderStatus: "",
        receiver: "",
        pageSize: 10,
        pageNum: 1,
      },
      orderStatusQuery: [],
      fbaOption: [
        {
          label: this.$t('running.suspended0'),
          value: '1'
        },
        {
          label: 'FBA',
          value: '0'
        },
        {
          label: 'YFF',
          value: '2'
        },
        /*{
          label: 'ZOZO',
          value: '3'
        },*/
        {
          label: 'RSL',
          value: '4'
        },
      ],
      orderStatusOptions: [],
      orderList: [],
      splitDialogVisible: false,
      originSpiltOrderInfo: {},
      spiltOrderInfo: {},
      total: 0,
      editOrderStatus: ['0', '4', '8', '24', '26', '40', '28', '32', '36', '82', '12', '16'],
      storeKeepingStatus: ['0', '4', '8', '24', '26', '40', '28', '32', '36', '82'],
      billOrderStatus: ['48', '88', '68', '52', '72', '84'],
      billOrderPayStatus: ['44', '64', '80'],
      spiltOrderRules: {
        goodsCount: [
          { required: true, message: this.$t('orderList.orderList57'), trigger: "change" },
          { validator: checkGoodsCount }
        ],
        refundCount: [
          { required: true, message: this.$t('orderList.orderList59'), trigger: "change" },
          { validator: checkRefundCount }
        ],
        destroyCount: [
          { required: true, message: this.$t('orderList.orderList61'), trigger: "change" },
          { validator: checkDestroyCount }
        ]
      },
      selectedOrders: [],
      configLists: {
        // logisticsCompanyConfigList:[], //快递
        inspectionConfigList: [],//标签
        // boxConfigList:[],//装箱
        // oppConfigList:[] //opp袋
      },

    };
  },
  methods: {
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'instorageOrder'
          }
        }).then((res) => {
          var result = [];
          if (res.data.code === 200) {
            var record = res.data.data;
            this.menuSettingData = record;
            result = JSON.parse(record.menuSetting);
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.originColumns.forEach((originItem) => {
                if (originItem.columnId == item.columnId) {
                  item.name = originItem.name;
                  item.width = originItem.minWidth;
                }
              })
              this.$set(item, "isShow", true);
            });
            let noSelectList = filterList(
              this.originColumns,
              result,
              "columnId"
            );
            this.columns = result.concat(noSelectList);
            this.asyncColumns = result;
            resolve();
          } else {
            this.columns = this.originColumns;
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            this.asyncColumns = this.columns;
            resolve();
          }
        });
      });
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this;
      var url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: this.$t('orderList.orderList83'),
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getOrderList();
          });
        } else {
          my.$message({
            type: "warning",
            message: this.$t('orderList.orderList84'),
          });
        }
      });
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    orderSelectedChanged (val) {
      this.selectedOrders = val;
    },
    async quickSave (val, row) {
      const { data: res } = await this.$http.post("/order/quickSave", { orderId: row.id, goodsNumber: val, quickSaveType: 8 });
      console.log(res)
    },
    async sendAll () {
      var urlArr = [];
      this.selectedOrders.forEach(el => {
        urlArr.push(el.id);
      })
      if (urlArr.length == 0) {
        this.$message.error(this.$t('inStorageOrder.inStorageOrder5'));
      } else {
        this.$confirm(this.$t('inStorageOrder.inStorageOrder6'), this.$t('inStorageOrder.inStorageOrder7'), {
          confirmButtonText: this.$t('submit'),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t('cancel'),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning"
        }).then(async () => {
          const { data: res } = await this.$http.post("storageOrder/batchSend", { "orderListStr": urlArr.toString() });
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: res.message
            }),
              await this.getOrderList();
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }).catch(() => {
          this.$message({
            type: "info",
            message: this.$t('orderList.orderList100')
          });
        });
      }
    },
    queryInfoClear () {
      this.queryInfo = {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        orderStatus: "",
        receiver: "",
        pageSize: 10,
        pageNum: 1,
      }
      this.orderDateRangeValue = [];
      this.shipDateRangeValue = [];
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    async getOrderList () {
      this.$store.dispatch("setOrderCount");
      const { data: res } = await this.$http.get("storageOrder/list", { params: this.queryInfo });
      this.orderList = res.data.list;
      this.total = res.data.total;
    },
    toTongkunDetail (row) {
      this.$router.push({
        name: 'buddleOrderDetail',
        query: {
          id: row.tongkunId
        }
      })
    },
    toOrderDetail (row) {
      // console.log(row);
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: '0'
        }
      })
    },
    toGoodsDetail (row) {
      window.open(row.taobaoUrl, '_blank')
    },
    //支付
    toOrderBillPay (row) {
      this.$router.push({
        name: 'orderBill',
        query: {
          id: row.id,
          isEdit: true
        }
      })
    },//账单
    toOrderBill (row) {
      this.$router.push({
        name: 'orderBill',
        query: {
          id: row.id,
          isEdit: false
        }
      })
    },
    toEditOrder (row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: '1'
        }
      })
    },
    toRefundOrder (row) {
      this.$confirm(this.$t('orderList.orderList88'), this.$t('orderList.orderList16'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.get(`cusArrOrder/rejectByCus/` + row.id);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('loginR.login13')
          });
          await this.getOrderList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t('orderList.orderList87')
        });
      });
    },
    toDestroyOrder (row) {
      this.$confirm(this.$t('orderList.orderList90'), this.$t('orderList.orderList18'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.get(`cusArrOrder/destroyByCus/` + row.id);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('orderList.orderList91')
          });
          await this.getOrderList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t('orderList.orderList92')
        });
      });
    },
    toStoreKeeping (row) {
      this.$confirm(this.$t('orderList.orderList94'), this.$t('orderList.orderList47'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.get(`cusArrOrder/storeKeeping/` + row.id);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('orderList.orderList95')
          });
          await this.getOrderList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t('orderList.orderList96')
        });
      });
    },
    toSendOrder (row) {
      this.$confirm(this.$t('orderList.orderList97'), this.$t('orderList.orderList98'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.get(`cusArrOrder/applySendOrder/` + row.id);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('orderList.orderList99')
          });
          await this.getOrderList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t('orderList.orderList100')
        });
      });
    },
    toCancelOrder (row) {
      this.$confirm(this.$t('orderList.orderList101'), this.$t('orderList.orderList102'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.get(`cusArrOrder/cancel/` + row.id);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('wzbg.wz18')
          });
          await this.getOrderList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t('orderList.orderList103')
        });
      });
    },
    toSpiltOrder (row) {
      this.splitDialogVisible = true;
      this.originSpiltOrderInfo = row;
      this.spiltOrderInfo = JSON.parse(JSON.stringify(row));
    },
    splitDialogClosed () {
      this.splitDialogVisible = false;
    },
    splitSave (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this.spiltOrderInfo);
          const { data: res } = await this.$http.post('cusArrOrder/spilt', this.spiltOrderInfo);
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.splitDialogClosed();
            await this.getOrderList();
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      });
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getOrderList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getOrderList();
    },
    // 排序
    toSort () {
      this.isVisibleSort = true;
    },
    // 加入购物车
    doAddCart () {
      if (this.selectedOrders.length > 0) {
        const idList = this.selectedOrders.map(item => item.id)
        const url = 'shopping/vehicle/copy/add'
        const params = {
          idList
        }
        this.$http.post(url, params).then(() => {
          this.$message.success(this.$t('success'))
        })
      } else {
        this.$message.error(this.$t('orderList.orderList125'));
      }
    },
  },
  watch: {
    orderDateRangeValue () {
      this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
      this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
    },
    shipDateRangeValue () {
      this.queryInfo.sendTimeStart = this.shipDateRangeValue[0];
      this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1];
    }
  },
  created () {
    this.orderStatusOptions = [
      { value: '0', label: this.$t('orderList.orderList8') },
      { value: '4', label: this.$t('orderList.orderList64') },
      { value: '8', label: this.$t('orderList.orderList65') },
      { value: '12', label: this.$t('orderList.orderList66') },
      { value: '16', label: this.$t('orderList.orderList10') },
      { value: '20', label: this.$t('orderList.orderList33') },
      { value: '24', label: this.$t('orderList.orderList34') },
      { value: '26', label: this.$t('orderList.orderList67') },
      { value: '28', label: this.$t('orderList.orderList68') },
      { value: '32', label: this.$t('orderList.orderList69') },
      { value: '36', label: this.$t('orderList.orderList70') },
      { value: '40', label: this.$t('orderList.orderList71') },
      { value: '44', label: this.$t('orderList.orderList11') },
      { value: '48', label: this.$t('orderList.orderList72') },
      { value: '52', label: this.$t('orderList.orderList73') },
      { value: '56', label: this.$t('status.status4') },
      { value: '60', label: this.$t('orderList.orderList74') },
      { value: '64', label: this.$t('orderList.orderList75') },
      { value: '68', label: this.$t('orderList.orderList76') },
      { value: '72', label: this.$t('orderList.orderList77') },
      { value: '76', label: this.$t('orderList.orderList78') },
      { value: '80', label: this.$t('orderList.orderList79') },
      { value: '82', label: this.$t('orderList.orderList80') },
      { value: '84', label: this.$t('orderList.orderList81') },
      { value: '88', label: this.$t('orderList.orderList82') },
    ];
    this.orderStatusQuery = [
      { value: '4', label: this.$t('orderList.orderList64') },
      { value: '8', label: this.$t('orderList.orderList65') },
      { value: '12', label: this.$t('orderList.orderList66') },
      { value: '16', label: this.$t('orderList.orderList10') },
      { value: '20', label: this.$t('orderList.orderList33') },
      { value: '44', label: this.$t('orderList.orderList11') },
      { value: '48', label: this.$t('orderList.orderList72') },
      { value: '88', label: this.$t('orderList.orderList82') },
    ];
    this.getAsyncColumns().then(() => {
      this.getOrderList();
    });
    // this.getConfigLists();
  },
};
</script>

<style lang="less" scoped>
.lx-text-left-row {
  display: flex;
}
.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
.query-title1 {
  /* padding-right: 10px; */
  height: 30px;
  line-height: 30px;
  width: 125px;
  padding: 0 10px 0 10px;
  text-align: right;
}
.lx-table-wrapper {
  padding-bottom: 43px;
  box-sizing: content-box;
}
.lx-page-pagination {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 100%;
  height: 35px;
  background-color: #fff;
}
</style>
